import {createAction, handleActions} from 'redux-actions';

const SET_DEPARTMENTS = 'journal/SET_DEPARTMENTS';
export const setDepartments = createAction(SET_DEPARTMENTS);
const SET_DEPARTMENT = 'journal/SET_DEPARTMENT';
export const setDepartment = createAction(SET_DEPARTMENT);

// 초기 state를 정해줍니다
let initialState = {
	param: {
		'disp_yn' : 'Y',
		'del_yn' : 'N',
	},
	records: [],
	record: {},
	stats: []
}

export default handleActions({
	[SET_DEPARTMENTS]: (state, action) => {
		// console.log(state);
		action.payload = action.payload ? action.payload : {}
		return {
			...state,
			records: action.payload.records ? action.payload.records : state.records,
		}
	},
	[SET_DEPARTMENT]: (state, action) => {
		return {
			...state,
			record: action.payload.record ? action.payload.record : state.record,
			stats: action.payload.stats ? action.payload.stats : state.stats,
		}
	},
}, initialState)
